<template>
  <div id="tab1" class="tab-item identite-produit">
    <div class="col-100 indentite-produit-top">
      <div class="col-33 identite-produit-top_left">
        <h2 class="orange">Informations</h2>
        <dl>
          <div v-if="substance.types && substance.types.length">
            <dt>TYPE DE SUBSTANCE</dt>
            <dd>{{ substance.types.join(", ") }}</dd>
          </div>
          <div v-if="substance.family">
            <dt>Famille chimique</dt>
            <dd>{{ substance.family }}</dd>
          </div>
          <div v-if="substance.principal_activity">
            <dt>Activité</dt>
            <dd>{{ substance.principal_activity | capitalize }}</dd>
          </div>
          <div v-for="(code_rac, i) in substance.code_rac" :key="i">
            <dt>{{ code_rac.rac_type }}</dt>
            <dd>{{ code_rac.code }}</dd>
          </div>
          <div v-if="substance.cas_number">
            <dt>Numéro CAS</dt>
            <dd>{{ substance.cas_number }}</dd>
          </div>
          <div v-if="substance.num_ec">
            <dt>Numéro EC</dt>
            <dd>{{ substance.num_ec }}</dd>
          </div>
          <div v-if="substance.num_cipac">
            <dt>Numéro CIPAC</dt>
            <dd>{{ substance.num_cipac }}</dd>
          </div>
          <div v-if="substance.aliases && substance.aliases.length">
            <dt>Synonyme(s) SA</dt>
            <dd>{{ substance.aliases.join(", ") }}</dd>
          </div>
          <div v-if="substance.chemical_formula">
            <dt>Nom chimique</dt>
            <dd>{{ substance.chemical_formula }}</dd>
          </div>
          <div v-if="substance.raw_formula">
            <dt>Formule brute</dt>
            <dd v-html="substance.raw_formula"></dd>
          </div>
        </dl>
      </div>
      <div
        v-if="substance.comment_biology"
        class="col-66 identite-produit-top_right"
      >
        <h2 class="orange">Description</h2>
        <p v-html="substance.comment_biology"></p>
      </div>
    </div>

    <div
      class="identite-produit-bottom"
      v-if="sorted_subtypes && sorted_subtypes.length"
    >
      <h2 class="orange pt-5">Données réglementaires</h2>
      <div class="table">
        <div class="row table_head">
          <div class="cell">Type de donnée</div>
          <div class="cell">Date d'approbation</div>
          <div class="cell">Date d'expiration</div>
        </div>
        <div v-for="(subtype, i) in sorted_subtypes" :key="i" class="row">
          <div class="cell" col-title="Type de donnée">
            Autorisation substance {{ subtype.name }}
            <p class="mt-2" v-if="subtype.dispositions_specifiques && subtype.name == 'Phytopharmaceutique'">
              <span class="text-gray-400"
                >DISPOSITIONS SPÉCIFIQUES (Annexe 540/2011) :</span
              >
              <span v-html="subtype.dispositions_specifiques"></span>
            </p>
          </div>
          <div class="cell" col-title="Date d'approbation">
            {{ subtype.approbation_date }}
          </div>
          <div class="cell" col-title="Date d'expiration">
            {{ subtype.expiration_date }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { naturalCompareOnName } from "@/utils/helpers";
export default {
  name: "SubstanceIdentity",

  props: {
    substance: Object,
  },
  computed: {
    // if 1 or more has date, then return only those who have date
    filtered_subtypes: function () {
      const subtypes = this.substance?.subtypes || [];
      const someSubtypeHasDate = subtypes.some((x) => !!x.approbation_date);
      if (someSubtypeHasDate)
        return subtypes.filter((x) => !!x.approbation_date);
      return subtypes;
    },

    sorted_subtypes: function () {
      if (this.filtered_subtypes) {
        let a = this.filtered_subtypes.sort(naturalCompareOnName);
        let b = [];
        // on met tous les phyto avant les Biocides
        a.forEach((element, index) => {
          if (element.name.indexOf("Phytopharmaceutique") !== -1) {
            b.unshift(element);
          } else {
            b.push(element);
          }
        });
        return b;
      }
    },
  },
};
</script>
